/*
This file is located in the main branch
Last time the file was updated (UTC): [02.07.2024 18:53:04]
Permissions to update outside the main branch: [false]
*/

import { ValidatedInput } from '@finbeat/react-toolkit';
import { TradeOrgFilterType } from 'models/api/tradeOrg';
import { useTranslation } from 'react-i18next';
import { Col, Row } from 'reactstrap';

const TradeOrgFilter = () => {
    const { t } = useTranslation();

    return (
        <Row>
            <Col>
                <ValidatedInput<TradeOrgFilterType>
                    id="ds-id"
                    name="id"
                    label={t('BackOfficeId')}
                />
            </Col>
            <Col>
                <ValidatedInput<TradeOrgFilterType>
                    id="ds-name"
                    name="fullName"
                    label={t('BackOfficeTradeOrg')}
                />
            </Col>
        </Row>
    );
};

export default TradeOrgFilter;
